import styled from "styled-components";

export const MainContentsItemLayout = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
`;

export const MainContentsItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 22px;
    background: ${(props) => props.theme.colors.white};
    /* gap: 12px; */
`;

export const DataItemBox = styled.p`
    font-size: 1.6rem;
    font-weight: 900;
    /* white-space: nowrap; */
    overflow: hidden; /* 넘치는 부분을 숨깁니다. */
    /* text-overflow: ellipsis; */
`;

export const DataHeadBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.title {
        display: flex;
        flex-direction: row;
        font-weight: 600;
        align-items: end;
        justify-content: start;
        gap: 3px;
    }
`;

export const StyledText = styled.p`
    font-size: 1.4rem; /* 텍스트 크기를 조절합니다. */
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
`;

export const ProfileDate = styled.p`
    width: 100%;
    color: ${(props) => props.theme.colors.placeholderTxt};
    font-size: 1.5rem;
    font-weight: 500;
`;

export const TitContentBox = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
`;